import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { transition, uebergangSanft } from '../../lib/motion';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  titel: string;
  beschreibung?: string;
  aktion?: ReactNode;
  className?: string;
}

/** Leerer Zustand: sagt, was fehlt, und bietet genau einen nächsten Schritt an. */
export function EmptyState({ icon, titel, beschreibung, aktion, className }: EmptyStateProps) {
  const reduziert = useReducedMotion();

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={transition(!!reduziert, uebergangSanft)}
      className={cn(
        'flex flex-col items-center justify-center rounded-xl border border-dashed border-border-strong',
        'bg-surface px-4 py-7 text-center',
        className,
      )}
    >
      {icon && (
        <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-pill bg-accent-soft text-accent-soft-fg">
          {icon}
        </span>
      )}
      <p className="text-base font-semibold text-fg">{titel}</p>
      {beschreibung && (
        <p className="mt-1.5 max-w-md text-sm leading-relaxed text-fg-muted">{beschreibung}</p>
      )}
      {aktion && <div className="mt-4">{aktion}</div>}
    </motion.div>
  );
}
